import { getGroups, getLimitedResultsGroups } from '../../../services/selections';
import { isSmallDevice } from '../../../services/utilities/devices';

export const getters = {
    isMarkingSelectionArea: state => state.markingSelectionArea,
    getSelectionData: state => state.selections?.[0],
    getSelectionCancelToken: () => () => Symbol ? Symbol() : new Date.getTime(),
    getCheckForCancelToken: (state) => (token) => state.selectionCancelTokens.includes(token),
    getSelectionGroups: (state, _getters) => {
        if (!state.userData) {
            return undefined;
        }
        if (!state.defaultMap) {
            return undefined;
        }
        return getGroups(_getters.getSelectionData, _getters.isMobile, state.userIsBrkAuthorized, state.userInfo.locale)
            .map((group, index) => {
                const foundIndex = _getters.getAllOrderedLayersIds.indexOf(group.id);
                return {
                    ...group,
                    order: foundIndex > - 1 ? foundIndex : index
                };
            })
            .sort((a, b) => {
                return a.order - b.order;
            });
    },
    getSelectionObjects: (state, _getters) => {
        return _getters.getSelectionGroups?.flatMap(
            ({ layer, objects }) => objects
                .map(({ feature, info, id }) => {
                    const objectinfo = Object.values(info);
                    const isInAccessibleMode = _getters.getIsInAccessibleMode ?? false;
                    const showPopup = isSmallDevice() && !_getters.getShowTableViewSmallDevices;
                    return {
                        feature,
                        layer,
                        layerId: layer.id,
                        layerTitle: layer.data.title,
                        type: layer.type,
                        nedGlobeRowId: info.nedGlobeRowId,
                        info: objectinfo.filter(
                            ({ displayInDetail, popup }) =>
                                (displayInDetail && !showPopup && !isInAccessibleMode) ||
                                (popup && showPopup && !isInAccessibleMode) ||
                                (popup && isInAccessibleMode)
                        ),
                        printInfo: objectinfo.filter(
                            ({ print }) => print
                        ),
                        id
                    };
                }
                )
        );
    },
    getSelectionObjectsCount: (state, _getters) => {
        return _getters.getSelectionObjects?.length || 0;
    },
    getSelectionObjectsSelectedGroup: (state, _getters) => {
        return _getters.getSelectionGroups?.[state.selectedGroupIndex];
    },
    getSelectionObjectsSelectedItem: (state, _getters) => {
        if (!_getters.getSelectionObjectsSelectedGroup) {
            return null;
        }
        const objectsInGroup = _getters.getSelectionObjects.filter(({ layerId }) => layerId === _getters.getSelectionObjectsSelectedGroup.id);

        return objectsInGroup[state.selectedItemIndex];
    },
    getSelectionObjectsSelectedItemObjectlistIndex: (state, _getters) => {
        const selectedItem = _getters.getSelectionObjectsSelectedItem;
        if (!selectedItem) {
            return 0;
        }
        return _getters.getSelectionObjects.findIndex(item => item.id === selectedItem.id && item.layerId === selectedItem.layerId);
    },
    getSelectionLimitedResultsGroups: (state, _getters) => {
        return getLimitedResultsGroups(_getters.getSelectionData);
    },
    getActiveLayerSelection: (state) => {
        return state.layerSelection;
    },
    getLocationSelection: (state) => {
        return state.locationSelection;
    },
    getResidentSelection: (state) => {
        return state.residentSelection;
    },
    getCompanySelection: (state) => {
        return state.companySelection;
    },
    getAddressAtPoint: (state) => {
        return state.addressAtPoint;
    },
    getOrderedTabs: (state, _getters) => {
        return state.tabOrder;
    },
    getAutoOpenRelations: (state) => {
        return state.autoOpenRelations;
    }
};
